import AlertDialog from './AlertDialog'

export { AlertDialog }
export default AlertDialog
